import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import styles from "../../../SpecialtyPersonalStyles.module.scss"
import metadata from './RentalsTenantsComponent.metadata.json5';
import TenantDetailsComponent from '../SubComponents/TenantDetails/TenantDetailsComponent'

function RentalTenantsComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated, dwellingPathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('RentalTenantsComponent');

    const modelVM = _.get(submissionVM, pathUpdated);
    const dwellingVM = _.get(submissionVM, dwellingPathUpdated);

    const seaRenDweOccCode = ['SeaDwe', 'RenDwe'];
    const seasonalOccCode = ['SeaDwe', 'SeaDwewitRen'];
    const vacantOccCode = ['VacCom', 'VacDwe', 'VacCon'];
    const rooHouseOccCode = ['RooHou'];
    const rentedOccCode = ['RenCon', 'RenDwe'];

    modelVM.value.isValidationReq = true;

    const isRentedtoOthers = () => !_.isUndefined(_.get(modelVM.value, 'istheresrentoothFie'))
        && _.get(modelVM.value, 'istheresrentoothFie')

    const isSeasonalOnly = () => !_.isUndefined(_.get(dwellingVM.value, 'propertyDetails.occFie'))
        && seasonalOccCode.includes(_.get(dwellingVM.value, 'propertyDetails.occFie'))

    const isSeasonalAndRentedDwellings = () => !_.isUndefined(_.get(dwellingVM.value, 'propertyDetails.occFie'))
        && seaRenDweOccCode.includes(_.get(dwellingVM.value, 'propertyDetails.occFie'))

    const isRoomingHouseOnly = () => !_.isUndefined(_.get(dwellingVM.value, 'propertyDetails.occFie'))
        && rooHouseOccCode.includes(_.get(dwellingVM.value, 'propertyDetails.occFie'))

    const isRentedOnly = () => !_.isUndefined(_.get(dwellingVM.value, 'propertyDetails.occFie'))
        && rentedOccCode.includes(_.get(dwellingVM.value, 'propertyDetails.occFie'))

    const isAllExceptVacant = () => !_.isUndefined(_.get(dwellingVM.value, 'propertyDetails.occFie'))
        && !vacantOccCode.includes(_.get(dwellingVM.value, 'propertyDetails.occFie'))

    const noOfTenantsGreaterThanZero = () => _.get(modelVM.value, 'numoftenFie') > 0


    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        tenantDetailsComponent: {
            data: modelVM.tenantDetails,
            updateWizardData,
            submissionVM,
            TenantDetailsPath: `${pathUpdated}.tenantDetails`,
            visible: noOfTenantsGreaterThanZero() && isRentedOnly()
        },
        istheresrentoothFie: {
            visible: isSeasonalAndRentedDwellings()
        },
        anndurWeeFie: { 
            visible: isRentedtoOthers() && isSeasonalOnly()
        },
        minRenArrFie: {
            visible: isRentedtoOthers() && isAllExceptVacant()
        },
        ifappplechethemonttenFie: {
            visible: isRentedtoOthers() && isSeasonalOnly()
        },
        janFie: {
            visible: isRentedtoOthers() && isSeasonalOnly()
        },
        febFie: {
            visible: isRentedtoOthers() && isSeasonalOnly()
        },
        marFie: {
            visible: isRentedtoOthers() && isSeasonalOnly()
        },
        aprFie: {
            visible: isRentedtoOthers() && isSeasonalOnly()
        },
        mayFie: {
            visible: isRentedtoOthers() && isSeasonalOnly()
        },
        junFie: {
            visible: isRentedtoOthers() && isSeasonalOnly()
        },
        julFie: {
            visible: isRentedtoOthers() && isSeasonalOnly()
        },
        augFie: {
            visible: isRentedtoOthers() && isSeasonalOnly()
        },
        sepFie: {
            visible: isRentedtoOthers() && isSeasonalOnly()
        },
        octFie: {
            visible: isRentedtoOthers() && isSeasonalOnly()
        },
        novFie: {
            visible: isRentedtoOthers() && isSeasonalOnly()
        },
        decFie: {
            visible: isRentedtoOthers() && isSeasonalOnly()
        },
        whaisthescrproforttenFie: {
            visible: isRentedtoOthers() && isAllExceptVacant()
        },
        othFie: {
            visible: isRentedtoOthers() && isAllExceptVacant()
                && _.get(modelVM.value, 'whaisthescrproforttenFie') === 'Other'
        },
        numofseluniFie: {
            visible: isRentedtoOthers() && isAllExceptVacant(),
            defaultValue: 0
        },
        ifappismotwatormotrenFie: {
            visible: isRentedtoOthers() && isAllExceptVacant() && !isRoomingHouseOnly(),
            defaultValue: false
        },
        tenantsTitle: {
            visible: isRentedtoOthers()
        },
        tenTypFie: {
            visible: isRentedtoOthers()
        },
        othdesFie: {
            visible: isRentedtoOthers() && _.get(modelVM.value, 'tenTypFie') === 'Other'
        },
        numoftenFie: {
            visible: isRentedtoOthers()
        },
        numoftenwhoarenotrothFie: {
            visible: isRentedtoOthers()
        },
        arethetenStuFie: {
            visible: isRentedtoOthers()
        },
        ifyesHowmanstuFie: {
            visible: isRentedtoOthers() && _.get(modelVM.value, 'arethetenStuFie')
        },
        doetheownchilivintdweFie: {
            visible: isRentedtoOthers()
        },
        howlonlivatthilocFie: {
            visible: noOfTenantsGreaterThanZero() && isRentedOnly()
        },
        aretheanyhotplaFie: {
            visible: noOfTenantsGreaterThanZero() && isRoomingHouseOnly(),
            defaultValue: false
        },
        istheanycooinrooFie: {
            visible: noOfTenantsGreaterThanZero() && isRoomingHouseOnly()
        },
        isthenospolinplaFie: {
            visible: noOfTenantsGreaterThanZero() && isRoomingHouseOnly()
        },
        aremeaprofortenFie: {
            visible: noOfTenantsGreaterThanZero() && isRoomingHouseOnly()
        },
        doyouallyoutentosusubFie: {
            visible: noOfTenantsGreaterThanZero() && isRentedOnly()
        },
        aretheanybusorfarppreFie: {
            visible: noOfTenantsGreaterThanZero()
        },
        ifyespledesFie: {
            visible: noOfTenantsGreaterThanZero() &&
                !_.isUndefined(_.get(modelVM.value, 'aretheanybusorfarppreFie')) && _.get(modelVM.value, 'aretheanybusorfarppreFie')
        }
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            tenantDetailsComponent: TenantDetailsComponent
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

RentalTenantsComponent.propTypes = wizardProps;
export default withRouter(RentalTenantsComponent);